import React from 'react';
import { toggleDocument, getDocumentsProgress, downloadDocumentsText, triggerDownload } from '../../data/journeys/journeyProgress';

function DocumentsWalletPanel({ journey, progress, onProgressUpdate }) {
	const { done, total, fraction } = getDocumentsProgress(journey, progress);
	const slug = journey.slug;
	const pct = Math.round(fraction * 100);

	return (
		<div className="guided-panel guided-panel--wallet">
			<div className="guided-panel__head">
				<div>
					<h3 className="guided-panel__title">Documents wallet</h3>
					<p className="guided-panel__intro">
						{done} of {total} documents ready — tick each when sorted
					</p>
				</div>
				<span className="guided-panel__stat">{pct}%</span>
			</div>
			<div className="guided-panel__progress" role="progressbar" aria-valuenow={pct} aria-valuemin="0" aria-valuemax="100">
				<div className="guided-panel__progress-fill" style={{ width: `${pct}%` }} />
			</div>
			<ul className="guided-wallet">
				{journey.documentsWallet.map((doc) => {
					const checked = !!progress.documents[doc.id];
					return (
						<li key={doc.id}>
							<label className={`guided-wallet__item${checked ? ' is-done' : ''}`}>
								<input
									type="checkbox"
									checked={checked}
									onChange={() => onProgressUpdate(toggleDocument(slug, doc.id))}
								/>
								<span className="guided-wallet__check" aria-hidden="true">{checked ? '✓' : ''}</span>
								<span className="guided-wallet__label">
									<strong>{doc.label}</strong>
									<small>{doc.note}</small>
								</span>
							</label>
						</li>
					);
				})}
			</ul>
			<button
				type="button"
				className="guided-panel__download"
				onClick={() => triggerDownload(`${slug}-documents.txt`, downloadDocumentsText(journey, progress))}
			>
				Download documents checklist
			</button>
		</div>
	);
}

export default DocumentsWalletPanel;
